<template>
  <div>
    代理记录
  </div>
</template>

<script>
export default {
components: {},
  data() {
    return {
      
    };
  },
created() {},
computed: {},
methods: {},
};
</script>

<style scoped lang='scss'>

</style>